(() => {
  'use strict';
  const panel = document.getElementById('nab-pwa');
  if (!panel) return;
  const install = document.getElementById('nab-pwa-install');
  const status = document.getElementById('nab-pwa-status');
  const offline = document.getElementById('nab-pwa-offline');
  const standalone = window.matchMedia('(display-mode: standalone)');
  let pendingPrompt = null;
  let installed = false;
  const isInstalled = () => installed || standalone.matches || navigator.standalone === true;
  function update() {
    panel.hidden = isInstalled() || !pendingPrompt || !navigator.onLine;
    install.hidden = !pendingPrompt || isInstalled() || !navigator.onLine;
    offline.hidden = navigator.onLine;
  }
  function say(message) {
    status.textContent = message;
    status.hidden = false;
  }
  window.addEventListener('beforeinstallprompt', event => {
    if (isInstalled()) return;
    event.preventDefault();
    pendingPrompt = event;
    update();
  });
  install.addEventListener('click', async () => {
    if (!pendingPrompt || !navigator.onLine) return;
    const prompt = pendingPrompt;
    pendingPrompt = null;
    install.disabled = true;
    update();
    try {
      await prompt.prompt();
      const result = await prompt.userChoice;
      say(result.outcome === 'accepted' ? 'تم قبول طلب التثبيت.' : 'تم إلغاء طلب التثبيت.');
    } catch {
      say('تعذر فتح نافذة التثبيت.');
    } finally {
      install.disabled = false;
      update();
    }
  });
  window.addEventListener('appinstalled', () => {
    installed = true;
    pendingPrompt = null;
    update();
  });
  standalone.addEventListener?.('change', update);
  window.addEventListener('online', update);
  window.addEventListener('offline', update);
  window.addEventListener('pageshow', update);
  update();
  // No service worker, Cache Storage, cart interception or customer-data storage.
})();
